import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Profile } from "./types";

interface EditUserDialogProps {
  user: Profile | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onUserChange: (user: Profile) => void;
  onSave: () => Promise<void>;
}

export const EditUserDialog = ({
  user,
  open,
  onOpenChange,
  onUserChange,
  onSave,
}: EditUserDialogProps) => {
  if (!user) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit User Information</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="grid w-full gap-2">
            <Label htmlFor="firstName">First Name</Label>
            <Input
              id="firstName"
              value={user.first_name || ''}
              onChange={(e) => onUserChange({
                ...user,
                first_name: e.target.value
              })}
            />
          </div>
          <div className="grid w-full gap-2">
            <Label htmlFor="lastName">Last Name</Label>
            <Input
              id="lastName"
              value={user.last_name || ''}
              onChange={(e) => onUserChange({
                ...user,
                last_name: e.target.value
              })}
            />
          </div>
          <div className="grid w-full gap-2">
            <Label htmlFor="phone">Phone Number</Label>
            <Input
              id="phone"
              value={user.phone_number || ''}
              onChange={(e) => onUserChange({
                ...user,
                phone_number: e.target.value
              })}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={onSave}>
            Save Changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};